import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Container } from "reactstrap";
import ToBeOrders from "./ToBeOrders/ToBeOrdersPage";
import resubmitClaims from "../../../assets/icon/resubmit-claims.svg";
import blackSaveIcon from "../../../assets/icon/black-save-icon.svg";
import OnOrder from "./OnOrder";
import ReceiveOrders from "./ReceiveOrders";
import OrderHistory from "./OrderHistory";
import BackOrderedItem from "./BackOrderedItem";
import backOrderedIcon from "assets/icon/backorderdIcon.svg";
import BackOrdered from "pages/Pending/BackOrdered";
import HoverImage from "react-hover-image/build";
import { useParams, useNavigate } from "react-router-dom";

const PurchaseOrders = () => {
  const [key, setKey] = useState("tobeorders");
  const { tab } = useParams();
  const navigate = useNavigate();
  const activeTab = tab || "tab-1";

  const handelKeyChange = (e) => {
    setKey(e.target);
  };

  const handleClick = (id) => {
    navigate(`/inventory-purchase-order/${id}`);
  };

  return (
    <Container
      fluid
      className="rounded bg-white p-3 pt-0 pb-1"
      // style={{ backgroundColor: "white" }}
    >
      {/* <div className="border-0 ">
        <div className="card-body p-3">
          <div>
            <Tabs
              id="controlled-tab-example"
              onSelect={handelKeyChange}
              activeKey={key}
            >
              <Tab
                eventKey="tobeorders"
                title={
                  <div style={{ fontSize: "16px" }}>
                    {" "}
                    <img
                      src={resubmitClaims}
                      alt=""
                      style={{ marginRight: "10px" }}
                    />
                    To Be Orders (234)
                  </div>
                }
              >
                <ToBeOrders />
              </Tab>
              <Tab
                eventKey="onorders"
                title={
                  <div style={{ fontSize: "16px" }}>
                    {" "}
                    <img
                      src={resubmitClaims}
                      alt=""
                      style={{ marginRight: "10px" }}
                    />
                    On Orders (123)
                  </div>
                }
              >
                <OnOrder />
              </Tab>
              <Tab
                eventKey="receiveorders"
                title={
                  <div style={{ fontSize: "16px" }}>
                    {" "}
                    <img
                      src={resubmitClaims}
                      alt=""
                      style={{ marginRight: "10px" }}
                    />
                    Receive Orders (26)
                  </div>
                }
              >
                <ReceiveOrders />
              </Tab>
              <Tab
                eventKey="orderhistory"
                title={
                  <div style={{ fontSize: "16px" }}>
                    {" "}
                    <img
                      src={resubmitClaims}
                      alt=""
                      style={{ marginRight: "10px" }}
                    />
                    Order History (12)
                  </div>
                }
              >
                <OrderHistory />
              </Tab>
              <Tab
                eventKey="backorders"
                title={
                  <div style={{ fontSize: "16px" }}>
                    {" "}
                    <img
                      src={resubmitClaims}
                      alt=""
                      style={{ marginRight: "10px" }}
                    />
                    Backordered Items (2)
                  </div>
                }
              >
                <BackOrderedItem />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div> */}
      <div className="bin_info">
        <div className="btn-container">
          <div className="btncroll">
            <button
              className={`btn-tab ${activeTab === "tab-1" ? "active" : ""}`}
              id="tab-1"
              onClick={() => handleClick("tab-1")}
            >
              {/* <div className="pur-img d-flex"> */}
              <img src={blackSaveIcon} alt="" style={{ marginRight: "8px" }} />
              To Be Ordered (20)
              {/* </div> */}
            </button>
            <button
              id="tab-2"
              className={`btn-tab  ${activeTab === "tab-2" ? "active" : ""}`}
              onClick={() => handleClick("tab-2")}
            >
              {" "}
              {/* <div className="pur-img d-flex"> */}
              <img src={blackSaveIcon} alt="" style={{ marginRight: "8px" }} />
              On Order (3)
              {/* </div> */}
            </button>
            <button
              className={`btn-tab ${activeTab === "tab-3" ? "active" : ""}`}
              id="tab-3"
              onClick={() => handleClick("tab-3")}
            >
              {" "}
              {/* <div className="pur-img d-flex"> */}
              <img src={blackSaveIcon} alt="" style={{ marginRight: "8px" }} />
              Receive Order (3)
              {/* </div> */}
            </button>
            <button
              className={`btn-tab ${activeTab === "tab-4" ? "active" : ""}`}
              id="tab-4"
              onClick={() => handleClick("tab-4")}
            >
              {/* <div className="pur-img d-flex"> */}
              <img src={blackSaveIcon} alt="" style={{ marginRight: "8px" }} />
              Order History (13)
              {/* </div> */}
            </button>
            <button
              className={`btn-tab ${activeTab === "tab-5" ? "active" : ""}`}
              id="tab-5"
              onClick={() => handleClick("tab-5")}
            >
              {" "}
              {/* <div className="pur-img d-flex"> */}
              <img
                src={backOrderedIcon}
                alt=""
                style={{ marginRight: "8px" }}
              />
              Backordered Items (10)
              {/* </div> */}
            </button>
          </div>
        </div>
      </div>
      <div className="tab-content">
        <div className={`tab-page ${activeTab === "tab-1" ? "active" : ""}`}>
          <ToBeOrders tab="tab-1" />
        </div>
        <div className={`tab-page ${activeTab === "tab-2" ? "active" : ""}`}>
          <OnOrder tab="tab-2" />
        </div>
        <div className={`tab-page ${activeTab === "tab-3" ? "active" : ""}`}>
          <ReceiveOrders tab="tab-3" />
        </div>
        <div className={`tab-page ${activeTab === "tab-4" ? "active" : ""}`}>
          <OrderHistory tab="tab-4" />
        </div>
        <div className={`tab-page ${activeTab === "tab-5" ? "active" : ""}`}>
          <BackOrderedItem tab="tab-5" />
        </div>
      </div>
    </Container>
  );
};

export default PurchaseOrders;
